<template>
  <div class="page">
    <el-tabs>
      <el-tab-pane label="待结算订单">
        <Wait />
      </el-tab-pane>
      <el-tab-pane label="已结算订单">
        <Accomplish />
      </el-tab-pane>
      <el-tab-pane label="结算关闭订单">
        <Close />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Wait from "./Wait.vue"
import Accomplish from "./Accomplish.vue"
import Close from "./Close.vue"
export default {
  components: { Wait, Accomplish, Close },
  data() {
    return {

    };
  },
  created() {

  },
  mounted() {

  },
  methods: {

  },
};
</script>

<style scoped></style>
